import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useListMyConnects = (pagination: { per_page: number; current_page: number }) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'myConnects', pagination],
    queryFn: () => connectService.listMyConnects(pagination)
  });

  return { myConnects: data?.data ?? [], pagination: data?.pagination, isLoading, error, refetch };
};
